import React, { useRef } from 'react';
import { motion, useMotionTemplate, useMotionValue, useSpring } from 'framer-motion';

export const TiltCard = ({ children, enabled, className = '', ...rest }) => {
  const ref = useRef(null);
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const rx = useSpring(rawX, { stiffness: 200, damping: 20 });
  const ry = useSpring(rawY, { stiffness: 200, damping: 20 });
  const mx = useMotionValue(50);
  const my = useMotionValue(50);
  const glow = useMotionTemplate`radial-gradient(420px circle at ${mx}% ${my}%, rgba(255,255,255,0.22), transparent 60%)`;

  const onMove = (e) => {
    if (!enabled) return;
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    rawY.set((px - 0.5) * 12);
    rawX.set((0.5 - py) * 12);
    mx.set(px * 100);
    my.set(py * 100);
  };
  const reset = () => { rawX.set(0); rawY.set(0); };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      style={enabled ? { rotateX: rx, rotateY: ry, transformPerspective: 900 } : undefined}
      whileHover={enabled ? { scale: 1.02 } : { y: -4 }}
      transition={{ duration: 0.3 }}
      className={`relative ${className}`}
      {...rest}
    >
      {children}
      {enabled && (
        <motion.div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 mix-blend-overlay" style={{ background: glow }} />
      )}
    </motion.div>
  );
};
